// extracted by mini-css-extract-plugin
module.exports = {"warning":"autorisatie-niveau-row_warning__10veb","relative":"autorisatie-niveau-row_relative__1b_Mr"};